var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoursePassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.5,
    r: 15.75,
    fill: "#BDE541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5477 23.5804L27.3749 14.5L29.75 17.0507L18.5477 28.5L12.25 22.0556L14.6187 19.5957L18.5477 23.5804Z",
    fill: "#193051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePassed);
export default __webpack_public_path__ + "static/media/course-passed.e395ff28de5d3bf1ccfd4d14005e49de.svg";
export { ForwardRef as ReactComponent };